import { render, staticRenderFns } from "./videoBlock.vue?vue&type=template&id=4272c61b&scoped=true&"
import script from "./videoBlock.vue?vue&type=script&lang=js&"
export * from "./videoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4272c61b",
  null
  
)

export default component.exports